function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M63.056 105.183c-.48.572-1.143 4.048-5.262 9.524-4.118 5.476-4.988 11.571-5.72 17.856-.915 7.857 6.864 10.952 11.44 13.571 0 0 4.805 15.952.915 15.238-3.89-.714 19.677 9.999 24.482 7.142s-8.008-19.047-5.263-23.332c2.746-4.286-19.447-17.142-14.643-26.19 4.805-9.047.23-20.951-5.948-13.809zM28 44.06s.407-24.9 7.23-34.909c.574-.838 3.04.144 3.59-.55.383-.48.742-.934 1.101-1.365 1.412-1.652 3.423-3.807 4.644-4.789 1.149-.91 2.657 1.7 2.873.718 1.196-5.507 4.069-2.155 4.069-2.155s-4.548 23.225-2.873 26.338c.982 1.844 3.806-11.157 6.775-10.535 2.322.479-2.945 16.281-2.945 16.281L43.751 46 28 44.06z",
  fill: "#FFBBC3"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.043 283c3.097 0 65.035-2.391 65.035-2.391l-15.246-74.602s20.582 40.887 28.348 44.713c7.766 3.826 18.82-.454 18.82-7.651 0-13.63-33.59-66.473-42.404-72.929-8.814-6.456-54.315-8.847-58.127-10.042-3.811-1.196-32.398-43.757-30.73-49.496 1.667-5.738 22.87-64.799 22.87-64.799L27.311 36s-7.838 19.63-13.34 32.997C6.896 86.165 1.632 98.742.155 106.537c-2.526 13.39 26.68 67.429 30.73 72.211 4.05 4.782 0 43.04 4.765 54.517C40.414 244.742 58.043 283 58.043 283z",
  fill: "#FB5347"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.227 282c3.107 0 15.773-.478 15.773-.478S46.995 175.835 43.172 174.64c-3.824-1.196-30.112-60.017-28.44-65.755 1.674-5.739 20.553-69.581 20.553-69.581L27.4 35s-7.863 19.63-13.383 32.997C6.918 85.165 1.636 97.742.155 105.537c-2.533 13.39 26.766 67.429 30.828 72.211 4.063 4.782 0 43.04 4.78 54.517C40.543 243.742 58.227 282 58.227 282z",
  fill: "#BA3543"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64.628 104.826s4.91-5.041 6.179.12c1.27 5.162-5.7 15.245-3.066 19.326 2.635 4.082 4.311 24.248 12.694 24.728 0 0 26.944-5.162 32.692-25.568 7.617-27.032-9.699-36.851-21.435-37.571-11.736-.72-23.232-6.002-27.064 5.281-3.832 11.284-5.748 8.403 0 13.684z",
  fill: "#0D215B"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101 96.749s4.397-16.391 18.32-10.453c13.924 5.94 18.565 18.055 7.573 25.419C115.705 119.198 101 122.167 101 96.749z",
  fill: "#0D215B"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M64 123c.552 0 1-.895 1-2s-.448-2-1-2-1 .895-1 2 .448 2 1 2z",
  fill: "#064CAB"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49 291l8.446-12.158L122.44 273 137 291H49z",
  fill: "#ED9A76"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M79.108 287.272s-31.351-72.92-19.385-90.896c9.5-14.286 32.954-22.139 46.428-16.58 18.906 7.805 41.642 79.542 43.796 91.605 2.153 12.063-61.506 24.149-70.84 15.871z",
  fill: "#244885"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97.747 165.015s-4.809 10.864-3.531 13.726c1.255 2.861 6.273-.049 6.273-.049s4.507-11.397 5.436-13.58c.929-2.182-7.063-3.346-8.178-.097z",
  fill: "#0264AD"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88 262l1.341-.429",
  stroke: "#064CAB",
  strokeWidth: 2
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.024 260.738l41.294-12.905",
  stroke: "#064CAB",
  strokeWidth: 2,
  strokeDasharray: "11.85 11.85"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M134.659 247.429L136 247",
  stroke: "#064CAB",
  strokeWidth: 2
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.25,
  d: "M66 242a2 2 0 100-4 2 2 0 000 4zm1-27a2 2 0 100-4 2 2 0 000 4zm16 70a2 2 0 100-4 2 2 0 000 4z",
  fill: "#fff"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37 233l27.406 13.979L75 279.036 57.036 280 37 233z",
  fill: "#A32B3C"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69 133.05s28.661-28.582 32.655-19.135c1.88 4.456 8.411 5.328 9.844 2.422 1.433-2.907.258 16.156-9.726 21.751-9.985 5.619-21.026 13.37-23.376 11.675-2.35-1.696-9.397-5.571-9.397-16.713z",
  fill: "#070634"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102 94.334s17.935-11.046 20.059.96c3.21 18.178-13.687 22.573-13.687 22.573s21.711 5.283 24.543-6.964c1.722-7.42 3.776-30.497-14.396-28.816-10.548.985-14.395 2.402-16.519 12.247z",
  fill: "#070634"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22 47s13.548 2.619 14 5",
  stroke: "#020202",
  strokeWidth: 2
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.544 289c18.397-3.348 36.577-9.947 35.402-16.571-2.159-12.195-24.944-84.72-43.892-92.611-7.987-3.324-19.476-1.913-29.501 2.797-3.118 6.146-10.89 21.067-9.354 29.58 5.756 31.803 13.695 41.989 23.745 63.366 3.597 7.652 18.947 11.717 23.6 13.439z",
  fill: "#064CAB"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.25,
  d: "M80 221a2 2 0 100-4 2 2 0 000 4zm1 18a2 2 0 100-4 2 2 0 000 4zm4-37a2 2 0 100-4 2 2 0 000 4zm15-2a2 2 0 10.001-3.999A2 2 0 00100 200zm-11 12a2 2 0 100-4 2 2 0 000 4zm3-22a2 2 0 100-4 2 2 0 000 4zm7 41a2 2 0 10.001-3.999A2 2 0 0099 231zm-16 28a2 2 0 100-4 2 2 0 000 4zm32-65a2 2 0 10.001-3.999A2 2 0 00115 194zm0 28a2 2 0 10.001-3.999A2 2 0 00115 222zm-9-8a2 2 0 10.001-3.999A2 2 0 00106 214zm24 7a2 2 0 10.001-3.999A2 2 0 00130 221zm5 14a2 2 0 10.001-3.999A2 2 0 00135 235zm-12-20a2 2 0 10.001-3.999A2 2 0 00123 215zm-8 20a2 2 0 10.001-3.999A2 2 0 00115 235zm-3 54a2 2 0 10.001-3.999A2 2 0 00112 289zm24-12a2 2 0 10.001-3.999A2 2 0 00136 277zm-38-35a2 2 0 100-4 2 2 0 000 4z",
  fill: "#fff"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89 254.601s5.96 26.074 12.306 27.312c6.346 1.239 40.755-11.167 42.469-14.566 1.713-3.399-6.805-26.463-10.014-28.163-3.185-1.699-40.997 8.74-44.761 15.417z",
  fill: "#fff"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.25,
  d: "M73 197a2 2 0 100-4 2 2 0 000 4z",
  fill: "#fff"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.004 187s-.71-18.7 17.996-7.337",
  stroke: "#020202",
  strokeWidth: 2
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.83 246c-6.403 2.51-11.559 5.239-12.83 7.505 0 0 5.923 26.171 12.23 27.414 1.415.268 4.221-.146 7.77-.975-6.235-8.821-7.29-23.758-7.17-33.944z",
  fill: "#F6E7DB"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M98.024 259.954s.449-.229 1.277-.619",
  stroke: "#020202",
  strokeWidth: 2
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.666 258.213c6.858-3.186 21.614-9.534 28.733-9.03",
  stroke: "#020202",
  strokeWidth: 2,
  strokeDasharray: "11.18 11.18"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M131.699 249.39c.497.114.946.298 1.301.527M102.351 95s-5.485 16.775 5.649 23",
  stroke: "#020202",
  strokeWidth: 2
});

var SvgWoman = function SvgWoman(props) {
  return React.createElement("svg", _extends({
    width: 155,
    height: 291,
    viewBox: "0 0 155 291",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

export default "data:image/svg+xml;base64,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";
export { SvgWoman as ReactComponent };